import { inject, Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { RootKeyboardShortcutService } from '../keyboard-shortcuts/root-keyboard-shortcut.service';
import { RootUndoService } from './root-undo.service';

@Injectable()
export class UndoRedoKeyboardShortcutService extends InjectableSuperclass {
  private undoService = inject(RootUndoService);
  private rootShortcutService = inject(RootKeyboardShortcutService);
  private eventTrackingService = inject(EventTrackingService);

  register() {
    this.subscribeTo(
      this.rootShortcutService.getEvent$('undo'),
      (eventInfo) => {
        if (this.undoService.canUndo()) {
          this.undoService.undo();
          this.eventTrackingService.track({
            id: 'undo',
            bucket: 'adjustment',
            ...eventInfo.eventTrackingValue,
          });
        }
      },
    );

    this.subscribeTo(
      this.rootShortcutService.getEvent$('redo'),
      (eventInfo) => {
        if (this.undoService.canRedo()) {
          this.undoService.redo();
          this.eventTrackingService.track({
            id: 'redo',
            bucket: 'adjustment',
            ...eventInfo.eventTrackingValue,
          });
        }
      },
    );
  }
}
